export default theme => ({
  qaPhotoUploadDialog: {},
  container: {
    flex: 1,
    backgroundColor: 'white',
    padding: 20,

    '& > *': {
      alignSelf: 'stretch',
    },
  },
  dropdown: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 10,

    '& > *': {
      alignSelf: 'stretch',
    },
    maxWidth: '35vw',
  },
  dropzone: {
    backgroundColor: '#F8F8F8',
    borderStyle: 'dashed',
    borderWidth: 2,
    borderColor: 'rgba(0,0,0,0.1)',
    color: 'rgba(0,0,0,0.4)',
    padding: 20,
    textAlign: 'center',
  },
});
